import { render } from "./Tabs.vue?vue&type=template&id=7930a478&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=7930a478&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7930a478"

export default script